import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { Get } from 'utils/axios'
import { storeLastView } from 'actions/lastView'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      countries: [],
      states: []
    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    getCountry = () => Get(
      `/countries`,
      this.getCountrySuccess,
      this.getCountryError,
      this.load
    )
    getCountrySuccess = payload => this.setState({ countries: payload })
    getCountryError = error => this.requestError( error )

    getCountryState = id => Get(
      `/countries/${ id }/states`,
      this.getCountryStateSuccess,
      this.getCountryStateError,
      this.load
    )
    getCountryStateSuccess = payload => this.setState({ states: payload })
    getCountryStateError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props } 
          states={ this.state.states }
          countries={ this.state.countries }
          onLoadDictionary={ this.state.loading }

          getCountryState={ this.getCountryState }
          getCountry={ this.getCountry }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return  connect( mapStateToProps, {
    storeLastView
  } )( WithHOC )
}

export default HOC